import styled, { css, DefaultTheme } from 'styled-components';

type WrapperProps = {
  border?: boolean;
  borderColor?: string;
  backgroundColor?: string;
  type?: string;
};

type WrapperModifiers = {
  [key: string]: (theme: DefaultTheme) => ReturnType<typeof css>;
};

const wrapperModifiers: WrapperModifiers = {
  border: (theme: DefaultTheme) => css`
    border: 1px solid ${theme.colors.neutral.neutral50};
    background: transparent;
  `,
};
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const Title = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;
export const TitleText = styled.span<{ type: string }>`
  ${({ type }) => css`
    font-size: ${type !== 'myProducts' ? '20px' : '24px'};
    font-weight: 700;
    line-height: 32px;
  `}
`;
export const SubTitle = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #808080;
  margin-bottom: 16px;
`;
export const Description = styled.span`
  margin-top: 16px;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #808080;
  white-space: normal; /* Permite a quebra de linha */
  word-wrap: break-word; /* Quebra palavras longas */
  word-break: break-word; /* Quebra palavras longas */
`;
export const Wrapper = styled.div<WrapperProps>`
  ${({ theme, border, backgroundColor, borderColor, type }) => css`
    background: ${backgroundColor || theme.colors.neutral.neutral0};
    cursor: pointer;
    border-radius: ${theme.border.radius};
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    flex: 1;
    max-width: '100%';

    a {
      text-decoration: none;
    }

    ${!!border && wrapperModifiers.border(theme)}
    ${borderColor &&
    css`
      border-color: ${borderColor};
    `}


    /* Largura para telas entre 800px e 1023px */
    @media (min-width: 800px) {
      max-width: ${type === 'myProducts' ? '100%' : '360px'};
      min-width: ${type === 'myProducts' ? '100%' : '360px'};
    }

    /* Largura para telas abaixo de 800px */
    @media (max-width: 799px) {
      max-width: ${type === 'myProducts' ? '100%' : '240px'};
      min-width: ${type === 'myProducts' ? '100%' : '240px'};
    }
  `}
`;
